























import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class ActionChoiceDialog extends Vue {
  @Prop({ default: false }) value!: boolean;

  get dialog() {
    return this.value;
  }

  set dialog(val: boolean) {
    this.$emit("input", val);
  }

  close() {
    this.dialog = false;
  }
}
